import React, { useState, useEffect, useRef } from 'react';
import { 
  Save, 
  Upload, 
  Trash2, 
  FileText, 
  Bot,
  CheckCircle,
  Loader2,
  Lock,
  BookOpen,
  Sparkles,
  Image,
  X,
  Plus,
  Activity,
  AlertCircle,
  CheckCircle2,
  Info,
  AlertTriangle,
  XCircle,
  Pencil,
  GraduationCap,
  Users,
  User,
  ChevronDown,
  ChevronRight,
  School,
  BarChart3
} from 'lucide-react';
import AnalyticsPanel from './AnalyticsPanel';

const API_BASE = process.env.REACT_APP_BACKEND_URL || '';

// ============================================
// ACADEMIC MANAGEMENT DATA (Demo Data)
// Hierarchy: Course → Subject → Group → Students
// ============================================
const ACADEMIC_DATA = {
  courses: [
    {
      id: '1-bach',
      name: '1º de Bachiller',
      subjects: [
        { 
          id: 'lengua-1', 
          name: 'Lengua Castellana y Literatura',
          groups: [
            {
              id: '1a-lengua',
              name: 'Grupo A',
              students: [
                { id: 's1a1', name: 'Carlos Mendoza' },
                { id: 's1a2', name: 'María García López' },
                { id: 's1a3', name: 'James Thompson' },
                { id: 's1a4', name: 'Sophie Dubois' },
                { id: 's1a5', name: 'Alessandro Rossi' },
                { id: 's1a6', name: 'Yuki Tanaka' },
                { id: 's1a7', name: 'Hans Müller' },
                { id: 's1a8', name: 'Elena Sánchez' },
                { id: 's1a9', name: 'Pablo Fernández' },
                { id: 's1a10', name: 'Camille Lefebvre' },
                { id: 's1a11', name: 'Antonio Ruiz' },
                { id: 's1a12', name: 'Emma Williams' }
              ]
            },
            {
              id: '1b-lengua',
              name: 'Grupo B',
              students: [
                { id: 's1b1', name: 'Lucía Martínez' },
                { id: 's1b2', name: 'David Chen' },
                { id: 's1b3', name: 'Amélie Bernard' },
                { id: 's1b4', name: 'Marco Bianchi' },
                { id: 's1b5', name: 'Kenji Yamamoto' },
                { id: 's1b6', name: 'Friedrich Weber' },
                { id: 's1b7', name: 'Isabel Torres' },
                { id: 's1b8', name: 'Robert Johnson' },
                { id: 's1b9', name: 'Ana Moreno' },
                { id: 's1b10', name: 'Pierre Martin' },
                { id: 's1b11', name: 'Laura Díaz' },
                { id: 's1b12', name: 'Takeshi Sato' },
                { id: 's1b13', name: 'Carmen Vega' }
              ]
            }
          ]
        }
      ]
    },
    {
      id: '2-bach',
      name: '2º de Bachiller',
      subjects: [
        { 
          id: 'filosofia', 
          name: 'Filosofía',
          groups: [
            {
              id: '2a-filo',
              name: 'Grupo A',
              students: [
                { id: 's2a1', name: 'Carlos Mendoza' },
                { id: 's2a2', name: 'Andrea Gómez' },
                { id: 's2a3', name: 'William Brown' },
                { id: 's2a4', name: 'Charlotte Moreau' },
                { id: 's2a5', name: 'Luca Ferrari' },
                { id: 's2a6', name: 'Sakura Nakamura' },
                { id: 's2a7', name: 'Klaus Schmidt' },
                { id: 's2a8', name: 'Sofía Herrera' },
                { id: 's2a9', name: 'Diego Navarro' },
                { id: 's2a10', name: 'Émile Rousseau' },
                { id: 's2a11', name: 'Victoria Lozano' }
              ]
            },
            {
              id: '2b-filo',
              name: 'Grupo B',
              students: [
                { id: 's2b1', name: 'Raúl Jiménez' },
                { id: 's2b2', name: 'Olivia Davis' },
                { id: 's2b3', name: 'Margaux Petit' },
                { id: 's2b4', name: 'Giovanni Romano' },
                { id: 's2b5', name: 'Haruki Watanabe' },
                { id: 's2b6', name: 'Maximilian Fischer' },
                { id: 's2b7', name: 'Paula Serrano' },
                { id: 's2b8', name: 'Michael Anderson' },
                { id: 's2b9', name: 'Cristina Molina' },
                { id: 's2b10', name: 'Louis Dupont' },
                { id: 's2b11', name: 'Marta Ortega' },
                { id: 's2b12', name: 'Benjamin Taylor' },
                { id: 's2b13', name: 'Rosa Delgado' },
                { id: 's2b14', name: 'Hiroshi Kimura' }
              ]
            }
          ]
        },
        { 
          id: 'historia-arte', 
          name: 'Historia del Arte',
          groups: [
            {
              id: '2a-arte',
              name: 'Grupo A',
              students: [
                { id: 's2a1', name: 'Carlos Mendoza' },
                { id: 's2a2', name: 'Andrea Gómez' },
                { id: 's2a3', name: 'William Brown' },
                { id: 's2a4', name: 'Charlotte Moreau' },
                { id: 's2a5', name: 'Luca Ferrari' },
                { id: 's2a6', name: 'Sakura Nakamura' },
                { id: 's2a7', name: 'Klaus Schmidt' },
                { id: 's2a8', name: 'Sofía Herrera' },
                { id: 's2a9', name: 'Diego Navarro' },
                { id: 's2a10', name: 'Émile Rousseau' },
                { id: 's2a11', name: 'Victoria Lozano' }
              ]
            },
            {
              id: '2b-arte',
              name: 'Grupo B',
              students: [
                { id: 's2b1', name: 'Raúl Jiménez' },
                { id: 's2b2', name: 'Olivia Davis' },
                { id: 's2b3', name: 'Margaux Petit' },
                { id: 's2b4', name: 'Giovanni Romano' },
                { id: 's2b5', name: 'Haruki Watanabe' },
                { id: 's2b6', name: 'Maximilian Fischer' },
                { id: 's2b7', name: 'Paula Serrano' },
                { id: 's2b8', name: 'Michael Anderson' },
                { id: 's2b9', name: 'Cristina Molina' },
                { id: 's2b10', name: 'Louis Dupont' },
                { id: 's2b11', name: 'Marta Ortega' },
                { id: 's2b12', name: 'Benjamin Taylor' },
                { id: 's2b13', name: 'Rosa Delgado' },
                { id: 's2b14', name: 'Hiroshi Kimura' }
              ]
            }
          ]
        },
        { 
          id: 'cultura-audiovisual', 
          name: 'Cultura Audiovisual',
          groups: [
            {
              id: '2a-cultura',
              name: 'Grupo A',
              students: [
                { id: 's2a1', name: 'Carlos Mendoza' },
                { id: 's2a2', name: 'Andrea Gómez' },
                { id: 's2a3', name: 'William Brown' },
                { id: 's2a4', name: 'Charlotte Moreau' },
                { id: 's2a5', name: 'Luca Ferrari' },
                { id: 's2a6', name: 'Sakura Nakamura' },
                { id: 's2a7', name: 'Klaus Schmidt' },
                { id: 's2a8', name: 'Sofía Herrera' },
                { id: 's2a9', name: 'Diego Navarro' },
                { id: 's2a10', name: 'Émile Rousseau' },
                { id: 's2a11', name: 'Victoria Lozano' }
              ]
            },
            {
              id: '2b-cultura',
              name: 'Grupo B',
              students: [
                { id: 's2b1', name: 'Raúl Jiménez' },
                { id: 's2b2', name: 'Olivia Davis' },
                { id: 's2b3', name: 'Margaux Petit' },
                { id: 's2b4', name: 'Giovanni Romano' },
                { id: 's2b5', name: 'Haruki Watanabe' },
                { id: 's2b6', name: 'Maximilian Fischer' },
                { id: 's2b7', name: 'Paula Serrano' },
                { id: 's2b8', name: 'Michael Anderson' },
                { id: 's2b9', name: 'Cristina Molina' },
                { id: 's2b10', name: 'Louis Dupont' },
                { id: 's2b11', name: 'Marta Ortega' },
                { id: 's2b12', name: 'Benjamin Taylor' },
                { id: 's2b13', name: 'Rosa Delgado' },
                { id: 's2b14', name: 'Hiroshi Kimura' }
              ]
            }
          ]
        }
      ]
    }
  ]
};

// ============================================
// ACADEMIC MANAGEMENT COMPONENT
// Hierarchy: Course → Subject → Group → Students
// ============================================
const AcademicManagement = () => {
  const [expandedCourses, setExpandedCourses] = useState({});
  const [expandedSubjects, setExpandedSubjects] = useState({});
  const [expandedGroups, setExpandedGroups] = useState({});
  const [selectedStudent, setSelectedStudent] = useState(null);

  const toggleCourse = (courseId) => {
    setExpandedCourses(prev => ({ ...prev, [courseId]: !prev[courseId] }));
  };

  const toggleSubject = (subjectId) => {
    setExpandedSubjects(prev => ({ ...prev, [subjectId]: !prev[subjectId] }));
  };

  const toggleGroup = (groupId) => {
    setExpandedGroups(prev => ({ ...prev, [groupId]: !prev[groupId] }));
  };

  // Count total groups and students for a course
  const getCourseStats = (course) => {
    let totalGroups = 0;
    let totalStudents = 0;
    course.subjects.forEach(subject => {
      totalGroups += subject.groups.length;
      subject.groups.forEach(group => {
        totalStudents += group.students.length;
      });
    });
    return { totalGroups, totalStudents, totalSubjects: course.subjects.length };
  };

  return (
    <div className="mb-4 bg-gray-800/50 rounded-xl border border-gray-700/50 overflow-hidden">
      {/* Header */}
      <div className="px-4 py-3 bg-gradient-to-r from-indigo-600/20 to-purple-600/20 border-b border-gray-700/50">
        <div className="flex items-center gap-2">
          <School className="w-5 h-5 text-indigo-400" />
          <h2 className="text-sm font-semibold text-white">Información de mis cursos</h2>
        </div>
      </div>
      
      {/* Content */}
      <div className="p-3">
        {ACADEMIC_DATA.courses.map(course => {
          const stats = getCourseStats(course);
          return (
            <div key={course.id} className="mb-2 last:mb-0">
              {/* Course Header (Level 1) */}
              <button
                onClick={() => toggleCourse(course.id)}
                className="w-full flex items-center gap-2 p-2.5 rounded-lg bg-gray-700/30 hover:bg-gray-700/50 transition-colors"
              >
                {expandedCourses[course.id] ? (
                  <ChevronDown className="w-4 h-4 text-gray-400" />
                ) : (
                  <ChevronRight className="w-4 h-4 text-gray-400" />
                )}
                <GraduationCap className="w-4 h-4 text-indigo-400" />
                <span className="text-sm font-medium text-white">{course.name}</span>
                <span className="ml-auto text-xs text-gray-500">
                  {stats.totalSubjects} asig. • {stats.totalGroups} grupos
                </span>
              </button>
              
              {/* Course Content - Subjects (Level 2) */}
              {expandedCourses[course.id] && (
                <div className="mt-2 ml-4 space-y-1.5">
                  {course.subjects.map(subject => (
                    <div key={subject.id}>
                      {/* Subject Header */}
                      <button
                        onClick={() => toggleSubject(subject.id)}
                        className="w-full flex items-center gap-2 p-2 rounded-lg bg-amber-500/10 hover:bg-amber-500/20 transition-colors border border-amber-500/20"
                      >
                        {expandedSubjects[subject.id] ? (
                          <ChevronDown className="w-3.5 h-3.5 text-amber-400" />
                        ) : (
                          <ChevronRight className="w-3.5 h-3.5 text-amber-400" />
                        )}
                        <BookOpen className="w-3.5 h-3.5 text-amber-400" />
                        <span className="text-xs font-medium text-amber-300">{subject.name}</span>
                        <span className="ml-auto text-xs text-gray-500">
                          {subject.groups.length} grupos
                        </span>
                      </button>
                      
                      {/* Groups (Level 3) */}
                      {expandedSubjects[subject.id] && (
                        <div className="mt-1.5 ml-4 space-y-1">
                          {subject.groups.map(group => (
                            <div key={group.id}>
                              {/* Group Header */}
                              <button
                                onClick={() => toggleGroup(group.id)}
                                className="w-full flex items-center gap-2 p-2 rounded-lg bg-gray-800/50 hover:bg-gray-700/30 transition-colors"
                              >
                                {expandedGroups[group.id] ? (
                                  <ChevronDown className="w-3 h-3 text-gray-500" />
                                ) : (
                                  <ChevronRight className="w-3 h-3 text-gray-500" />
                                )}
                                <Users className="w-3 h-3 text-emerald-400" />
                                <span className="text-xs font-medium text-gray-300">{group.name}</span>
                                <span className="ml-auto text-xs text-gray-500">
                                  {group.students.length} alumnos
                                </span>
                              </button>
                              
                              {/* Students List (Level 4) */}
                              {expandedGroups[group.id] && (
                                <div className="mt-1 ml-5 p-2 bg-gray-900/30 rounded-lg">
                                  <div className="grid grid-cols-2 gap-1">
                                    {group.students.map(student => (
                                      <div
                                        key={student.id}
                                        className={`flex items-center gap-1.5 px-2 py-1 rounded text-xs transition-colors cursor-pointer ${
                                          selectedStudent === student.id
                                            ? 'bg-indigo-500/30 text-indigo-300'
                                            : 'text-gray-400 hover:bg-gray-700/30 hover:text-gray-300'
                                        }`}
                                        onClick={() => setSelectedStudent(
                                          selectedStudent === student.id ? null : student.id
                                        )}
                                      >
                                        <User className="w-3 h-3 flex-shrink-0" />
                                        <span className="truncate">{student.name}</span>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

// Alert Modal Component - Replaces native alert()
const AlertModal = ({ isOpen, onClose, title, message, type = 'error' }) => {
  if (!isOpen) return null;

  const getIcon = () => {
    switch (type) {
      case 'success':
        return <CheckCircle2 className="w-8 h-8 text-emerald-400" />;
      case 'warning':
        return <AlertTriangle className="w-8 h-8 text-amber-400" />;
      case 'info':
        return <Info className="w-8 h-8 text-blue-400" />;
      case 'error':
      default:
        return <XCircle className="w-8 h-8 text-red-400" />;
    }
  };

  const getHeaderColor = () => {
    switch (type) {
      case 'success':
        return 'border-emerald-500/30';
      case 'warning':
        return 'border-amber-500/30';
      case 'info':
        return 'border-blue-500/30';
      case 'error':
      default:
        return 'border-red-500/30';
    }
  };

  const getButtonColor = () => {
    switch (type) {
      case 'success':
        return 'bg-emerald-500 hover:bg-emerald-600';
      case 'warning':
        return 'bg-amber-500 hover:bg-amber-600';
      case 'info':
        return 'bg-blue-500 hover:bg-blue-600';
      case 'error':
      default:
        return 'bg-red-500 hover:bg-red-600';
    }
  };

  return (
    <div 
      className="fixed inset-0 bg-black/70 flex items-center justify-center z-[100] p-4"
      onClick={onClose}
    >
      <div 
        className={`bg-gray-900 rounded-xl border border-gray-700 max-w-sm w-full overflow-hidden shadow-2xl ${getHeaderColor()}`}
        onClick={e => e.stopPropagation()}
      >
        {/* Header */}
        <div className={`flex items-center justify-between p-4 border-b border-gray-700`}>
          <div className="flex items-center gap-3">
            {getIcon()}
            <h3 className="text-base font-semibold text-white">{title || 'Aviso'}</h3>
          </div>
          <button
            onClick={onClose}
            className="p-1 hover:bg-gray-700 rounded-lg transition-colors"
          >
            <X className="w-4 h-4 text-gray-400" />
          </button>
        </div>
        
        {/* Content */}
        <div className="p-4">
          <p className="text-sm text-gray-300 leading-relaxed">{message}</p>
        </div>
        
        {/* Footer */}
        <div className="p-4 pt-0 flex justify-end">
          <button
            onClick={onClose}
            className={`px-4 py-2 ${getButtonColor()} rounded-lg text-sm font-medium text-white transition-all`}
          >
            Entendido
          </button>
        </div>
      </div>
    </div>
  );
};

// Confirm Modal Component - Replaces native confirm()
const ConfirmModal = ({ isOpen, onClose, onConfirm, title, message, confirmText = 'Confirmar', cancelText = 'Cancelar', type = 'warning' }) => {
  if (!isOpen) return null;

  const getIcon = () => {
    switch (type) {
      case 'danger':
        return <Trash2 className="w-8 h-8 text-red-400" />;
      case 'warning':
      default:
        return <AlertTriangle className="w-8 h-8 text-amber-400" />;
    }
  };

  const getConfirmButtonColor = () => {
    switch (type) {
      case 'danger':
        return 'bg-red-500 hover:bg-red-600';
      case 'warning':
      default:
        return 'bg-amber-500 hover:bg-amber-600';
    }
  };

  return (
    <div 
      className="fixed inset-0 bg-black/70 flex items-center justify-center z-[100] p-4"
      onClick={onClose}
    >
      <div 
        className="bg-gray-900 rounded-xl border border-gray-700 max-w-sm w-full overflow-hidden shadow-2xl"
        onClick={e => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-gray-700">
          <div className="flex items-center gap-3">
            {getIcon()}
            <h3 className="text-base font-semibold text-white">{title || 'Confirmar acción'}</h3>
          </div>
          <button
            onClick={onClose}
            className="p-1 hover:bg-gray-700 rounded-lg transition-colors"
          >
            <X className="w-4 h-4 text-gray-400" />
          </button>
        </div>
        
        {/* Content */}
        <div className="p-4">
          <p className="text-sm text-gray-300 leading-relaxed">{message}</p>
        </div>
        
        {/* Footer */}
        <div className="p-4 pt-0 flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-700 hover:bg-gray-600 rounded-lg text-sm font-medium text-gray-200 transition-all"
          >
            {cancelText}
          </button>
          <button
            onClick={() => {
              onConfirm();
              onClose();
            }}
            className={`px-4 py-2 ${getConfirmButtonColor()} rounded-lg text-sm font-medium text-white transition-all`}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

// Minimalist Triangle Icon for Professor Default Agent
const TriangleIcon = ({ className }) => (
  <svg 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
    className={className}
  >
    <polygon points="12 3 22 20 2 20" />
  </svg>
);

// Minimalist Circle Icon for Student Default Agent
const CircleIcon = ({ className }) => (
  <svg 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2"
    className={className}
  >
    <circle cx="12" cy="12" r="9" />
  </svg>
);

// 5-Agent Model Configuration
// - Subject agents (filosofia, historia-arte, cultura-audiovisual): Unified personality for students AND professors
// - Default agents: Separate for students and professors
const AGENT_PROFILES = [
  // Subject agents - Shared between students and professors (same personality)
  { 
    id: 'filosofia', 
    name: 'Filosofía',
    description: 'Para alumnos y profesores • Filosofía y pensamiento crítico',
    iconUrl: 'https://customer-assets.emergentagent.com/job_elegant-assistant-1/artifacts/srpm4yza_milo_filosofia.png',
    promptId: 'student-filosofia',  // Editing this syncs to teacher-filosofia automatically
    isDefault: false,
    isShared: true  // Indicates this agent is shared between roles
  },
  { 
    id: 'historia-arte', 
    name: 'Historia del Arte',
    description: 'Para alumnos y profesores • Arte y movimientos artísticos',
    iconUrl: 'https://customer-assets.emergentagent.com/job_elegant-assistant-1/artifacts/gnhmb7ta_milo_historia_arte.png',
    promptId: 'student-historia-arte',
    isDefault: false,
    isShared: true
  },
  { 
    id: 'cultura-audiovisual', 
    name: 'Cultura Audiovisual',
    description: 'Para alumnos y profesores • Cine, fotografía y medios',
    iconUrl: 'https://customer-assets.emergentagent.com/job_elegant-assistant-1/artifacts/r6hvoxa7_milo_cultura_audiovisual.png',
    promptId: 'student-cultura-audiovisual',
    isDefault: false,
    isShared: true
  },
  // Default agents - Role-specific
  { 
    id: 'default-student', 
    name: 'Default Alumnos',
    description: 'Exclusivo para estudiantes',
    iconType: 'circle',
    promptId: 'student-default',
    isDefault: true,
    isShared: false
  },
  { 
    id: 'default-teacher', 
    name: 'Default Profesores',
    description: 'Exclusivo para docentes',
    iconType: 'triangle',
    promptId: 'teacher-default',
    isDefault: true,
    isShared: false
  }
];

// PIN Input Component
const PinInput = ({ onSubmit, error, isLoading, onCancel }) => {
  const [pin, setPin] = useState(['', '', '', '']);
  const inputRefs = [useRef(), useRef(), useRef(), useRef()];

  const handleChange = (index, value) => {
    if (!/^\d*$/.test(value)) return;
    
    const newPin = [...pin];
    newPin[index] = value.slice(-1);
    setPin(newPin);
    
    if (value && index < 3) {
      inputRefs[index + 1].current?.focus();
    }
    
    if (index === 3 && value) {
      const fullPin = [...newPin.slice(0, 3), value.slice(-1)].join('');
      if (fullPin.length === 4) {
        onSubmit(fullPin);
      }
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === 'Backspace' && !pin[index] && index > 0) {
      inputRefs[index - 1].current?.focus();
    }
    if (e.key === 'Escape') {
      onCancel();
    }
  };

  return (
    <div className="flex flex-col items-center p-4 bg-gray-800/50 rounded-xl border border-gray-700">
      <Lock className="w-6 h-6 text-blue-400 mb-2" />
      <h3 className="text-sm font-medium text-white mb-1">Editar Instrucciones</h3>
      <p className="text-xs text-gray-400 mb-3">Introduce el PIN para continuar</p>
      
      <div className="flex gap-2 mb-2">
        {pin.map((digit, index) => (
          <input
            key={index}
            ref={inputRefs[index]}
            type="password"
            inputMode="numeric"
            maxLength={1}
            value={digit}
            onChange={(e) => handleChange(index, e.target.value)}
            onKeyDown={(e) => handleKeyDown(index, e)}
            disabled={isLoading}
            className="w-9 h-10 text-center text-lg font-bold bg-gray-800 border border-gray-600 rounded-lg text-white focus:border-blue-500 focus:ring-1 focus:ring-blue-500 outline-none"
            autoFocus={index === 0}
          />
        ))}
      </div>
      
      {error && (
        <p className="text-red-400 text-xs mb-2">{error}</p>
      )}
      
      <button
        onClick={onCancel}
        className="text-xs text-gray-500 hover:text-gray-300"
      >
        Cancelar
      </button>
    </div>
  );
};

// Agent Card Component
const AgentCard = ({ 
  agent, 
  isSelected, 
  onClick, 
  ragCount
}) => {
  return (
    <button
      onClick={onClick}
      className={`w-full flex items-center gap-2 p-3 rounded-xl transition-all border ${
        isSelected
          ? 'bg-blue-500/10 border-blue-500/30'
          : 'bg-gray-800/30 border-gray-700/50 hover:bg-gray-800/50 hover:border-gray-600'
      }`}
      data-testid={`agent-card-${agent.id}`}
    >
      {agent.iconUrl ? (
        <img src={agent.iconUrl} alt={agent.name} className="w-10 h-10 object-contain" />
      ) : agent.iconType === 'triangle' ? (
        <div className={`w-10 h-10 flex items-center justify-center ${
          isSelected ? 'text-blue-400' : 'text-gray-400'
        }`}>
          <TriangleIcon className="w-7 h-7" />
        </div>
      ) : agent.iconType === 'circle' ? (
        <div className={`w-10 h-10 flex items-center justify-center ${
          isSelected ? 'text-blue-400' : 'text-gray-400'
        }`}>
          <CircleIcon className="w-7 h-7" />
        </div>
      ) : (
        <div className="w-10 h-10 rounded-full bg-blue-500/20 flex items-center justify-center">
          <Bot className="w-5 h-5 text-blue-400" />
        </div>
      )}
      <div className="flex-1 text-left min-w-0">
        <div className="flex items-center gap-1.5 flex-wrap">
          <h3 className={`text-sm font-medium ${isSelected ? 'text-white' : 'text-gray-300'}`}>
            {agent.name}
          </h3>
          {agent.isShared && (
            <span className="flex-shrink-0 text-[9px] bg-purple-500/30 text-purple-300 px-1 py-0.5 rounded">
              Compartido
            </span>
          )}
        </div>
        {ragCount > 0 && (
          <span className="text-xs text-gray-500">
            {ragCount} doc{ragCount > 1 ? 's' : ''}
          </span>
        )}
      </div>
    </button>
  );
};

// Knowledge Documents Section (renamed from RAG)

// Editable Subject Header Component
const EditableSubjectHeader = ({ subject, onUpdate, isLoading }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editName, setEditName] = useState(subject.name);
  const [editDescription, setEditDescription] = useState(subject.description);
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    if (!editName.trim()) return;
    
    setSaving(true);
    try {
      await onUpdate({
        name: editName.trim(),
        description: editDescription.trim()
      });
      setIsEditing(false);
    } catch (error) {
      console.error('Error updating subject:', error);
    } finally {
      setSaving(false);
    }
  };

  const handleCancel = () => {
    setEditName(subject.name);
    setEditDescription(subject.description);
    setIsEditing(false);
  };

  if (isEditing) {
    return (
      <div className="bg-gray-800/50 rounded-xl border border-amber-500/30 p-3 space-y-3">
        <div>
          <label className="text-xs text-gray-400 block mb-1">Nombre de la asignatura</label>
          <input
            type="text"
            value={editName}
            onChange={(e) => setEditName(e.target.value)}
            className="w-full bg-gray-700 border border-gray-600 rounded-lg px-3 py-2 text-sm text-white focus:ring-2 focus:ring-amber-500 focus:border-transparent"
            placeholder="Ej: Historia del Arte, Videojuegos, etc."
            data-testid="edit-subject-name"
          />
        </div>
        <div>
          <label className="text-xs text-gray-400 block mb-1">Descripción</label>
          <input
            type="text"
            value={editDescription}
            onChange={(e) => setEditDescription(e.target.value)}
            className="w-full bg-gray-700 border border-gray-600 rounded-lg px-3 py-2 text-sm text-white focus:ring-2 focus:ring-amber-500 focus:border-transparent"
            placeholder="Breve descripción de la asignatura"
            data-testid="edit-subject-description"
          />
        </div>
        <div className="flex items-center gap-2 pt-1">
          <button
            onClick={handleSave}
            disabled={saving || !editName.trim()}
            className="flex items-center gap-1.5 px-3 py-1.5 bg-amber-500 hover:bg-amber-600 disabled:bg-gray-600 text-white text-xs font-medium rounded-lg transition-colors"
            data-testid="save-subject-btn"
          >
            {saving ? <Loader2 className="w-3 h-3 animate-spin" /> : <Save className="w-3 h-3" />}
            Guardar
          </button>
          <button
            onClick={handleCancel}
            className="px-3 py-1.5 bg-gray-600 hover:bg-gray-500 text-white text-xs font-medium rounded-lg transition-colors"
          >
            Cancelar
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-start justify-between pb-3 border-b border-gray-700/50">
      <div className="flex-1">
        <h2 className="text-base font-semibold text-white">{subject.name}</h2>
        <p className="text-xs text-gray-400">{subject.description}</p>
      </div>
      {!subject.isDefault && (
        <button
          onClick={() => setIsEditing(true)}
          className="p-1.5 text-gray-400 hover:text-amber-400 hover:bg-gray-700/50 rounded-lg transition-colors"
          title="Editar nombre y descripción"
          data-testid="edit-subject-trigger"
        >
          <Pencil className="w-4 h-4" />
        </button>
      )}
    </div>
  );
};

const KnowledgeSection = ({ docs, subjectId, onUpload, onDelete, isLoading }) => {
  const fileInputRef = useRef();
  const [uploadProgress, setUploadProgress] = useState(null); // null, 'preparing', 'chunking', 'indexing', 'done'
  const filteredDocs = docs.filter(d => d.subject_id === subjectId);
  
  const handleFileSelect = async (e) => {
    const file = e.target.files[0];
    if (file) {
      // Show progress modal - total minimum 6 seconds
      setUploadProgress('preparing');
      
      // Stage transitions - 2 seconds each
      setTimeout(() => setUploadProgress('chunking'), 2000);
      setTimeout(() => setUploadProgress('indexing'), 4000);
      
      try {
        // Start upload but ensure minimum 6 seconds total display
        const uploadPromise = onUpload(file, subjectId);
        const minTimePromise = new Promise(resolve => setTimeout(resolve, 6000));
        
        await Promise.all([uploadPromise, minTimePromise]);
        
        setUploadProgress('done');
        setTimeout(() => setUploadProgress(null), 1500);
      } catch (error) {
        setUploadProgress(null);
      }
      
      e.target.value = '';
    }
  };

  const getProgressMessage = () => {
    switch (uploadProgress) {
      case 'preparing':
        return { title: 'Preparando documento', subtitle: 'Extrayendo texto del archivo...' };
      case 'chunking':
        return { title: 'Creando chunks', subtitle: 'Dividiendo en fragmentos semánticos...' };
      case 'indexing':
        return { title: 'Añadiendo conocimiento', subtitle: 'Generando embeddings con IA...' };
      case 'done':
        return { title: '¡Listo!', subtitle: 'Documento indexado correctamente' };
      default:
        return null;
    }
  };

  const progress = getProgressMessage();

  return (
    <div className="bg-gray-800/30 rounded-xl border border-gray-700/50 p-3">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <FileText className="w-4 h-4 text-blue-400" />
          <h3 className="text-sm font-medium text-white">Conocimientos</h3>
          <span className="text-xs bg-gray-700/50 text-gray-400 px-1.5 py-0.5 rounded">
            {filteredDocs.length}
          </span>
        </div>
        <button
          onClick={() => fileInputRef.current?.click()}
          disabled={isLoading || uploadProgress}
          className="flex items-center gap-1.5 px-2.5 py-1 bg-blue-500/20 hover:bg-blue-500/30 rounded-lg text-xs text-blue-400 transition-all disabled:opacity-50"
        >
          <Upload className="w-3.5 h-3.5" />
          <span>Subir</span>
        </button>
        <input
          ref={fileInputRef}
          type="file"
          accept=".txt,.md,.pdf,.docx,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          onChange={handleFileSelect}
          className="hidden"
        />
      </div>
      
      {/* Supported formats hint */}
      <p className="text-[10px] text-gray-600 mb-2">
        Formatos: PDF, Word (.docx), texto (.txt, .md)
      </p>
      
      {filteredDocs.length === 0 ? (
        <div className="text-center py-4 text-gray-500">
          <p className="text-xs">Sin documentos</p>
        </div>
      ) : (
        <div className="space-y-1.5">
          {filteredDocs.map(doc => (
            <div
              key={doc.id}
              className="flex items-center gap-2 p-2 bg-gray-800/50 rounded-lg"
            >
              <FileText className="w-3.5 h-3.5 text-gray-500 flex-shrink-0" />
              <span className="flex-1 text-xs text-gray-300 truncate">{doc.filename}</span>
              <button
                onClick={() => onDelete(doc.id)}
                className="p-1 text-gray-500 hover:text-red-400 rounded transition-all"
              >
                <Trash2 className="w-3.5 h-3.5" />
              </button>
            </div>
          ))}
        </div>
      )}

      {/* Upload Progress Modal */}
      {uploadProgress && progress && (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50" data-testid="upload-progress-modal">
          <div className="bg-gray-900 rounded-xl border border-gray-700 p-6 max-w-sm w-full mx-4 shadow-2xl">
            {/* Spinner */}
            {uploadProgress !== 'done' && (
              <div className="flex justify-center mb-4">
                <Loader2 className="w-10 h-10 text-violet-400 animate-spin" />
              </div>
            )}
            
            {/* Checkmark for done */}
            {uploadProgress === 'done' && (
              <div className="flex justify-center mb-4">
                <CheckCircle className="w-10 h-10 text-emerald-400" />
              </div>
            )}
            
            {/* Title */}
            <h3 className="text-lg font-semibold text-white text-center mb-1">
              {progress.title}
            </h3>
            <p className="text-sm text-gray-400 text-center mb-4">
              {progress.subtitle}
            </p>
            
            {/* Progress Bar */}
            {uploadProgress !== 'done' && (
              <div className="w-full bg-gray-700 rounded-full h-2 overflow-hidden">
                <div 
                  className="h-full bg-gradient-to-r from-blue-500 to-violet-500 rounded-full transition-all duration-500 ease-out"
                  style={{ 
                    width: uploadProgress === 'preparing' ? '33%' : 
                           uploadProgress === 'chunking' ? '66%' : 
                           uploadProgress === 'indexing' ? '90%' : '100%'
                  }}
                />
              </div>
            )}
            
            {/* Steps indicator */}
            <div className="flex justify-between mt-4 text-xs">
              <div className={`flex items-center gap-1 ${uploadProgress === 'preparing' ? 'text-blue-400' : 'text-gray-500'}`}>
                <span className={uploadProgress !== 'preparing' && uploadProgress !== null ? 'text-emerald-400' : ''}>
                  {uploadProgress !== 'preparing' && uploadProgress !== null ? '✓' : '○'}
                </span>
                Preparar
              </div>
              <div className={`flex items-center gap-1 ${uploadProgress === 'chunking' ? 'text-blue-400' : 'text-gray-500'}`}>
                <span className={['indexing', 'done'].includes(uploadProgress) ? 'text-emerald-400' : ''}>
                  {['indexing', 'done'].includes(uploadProgress) ? '✓' : '○'}
                </span>
                Chunks
              </div>
              <div className={`flex items-center gap-1 ${uploadProgress === 'indexing' ? 'text-blue-400' : 'text-gray-500'}`}>
                <span className={uploadProgress === 'done' ? 'text-emerald-400' : ''}>
                  {uploadProgress === 'done' ? '✓' : '○'}
                </span>
                Indexar
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// Multimedia Section
const MultimediaSection = ({ items, subjectId, onUpload, onDelete, onUpdate, isLoading, onShowAlert }) => {
  const fileInputRef = useRef();
  const [keywords, setKeywords] = useState('');
  const [caption, setCaption] = useState('');
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [editKeywords, setEditKeywords] = useState('');
  const [editCaption, setEditCaption] = useState('');
  const [isSavingEdit, setIsSavingEdit] = useState(false);
  
  const filteredItems = items.filter(item => item.subject_id === subjectId);
  
  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Validate file size on client side (hard cap 10MB)
      if (file.size > 10 * 1024 * 1024) {
        onShowAlert('Archivo demasiado grande', 'El archivo excede el límite de 10MB. Por favor, selecciona un archivo más pequeño.', 'error');
        return;
      }
      setSelectedFile(file);
      setPreviewUrl(URL.createObjectURL(file));
    }
  };

  const handleUpload = async () => {
    if (!selectedFile || !keywords.trim()) return;
    
    setIsUploading(true);
    try {
      await onUpload(selectedFile, subjectId, keywords, caption);
      setSelectedFile(null);
      setPreviewUrl(null);
      setKeywords('');
      setCaption('');
      if (fileInputRef.current) fileInputRef.current.value = '';
    } finally {
      setIsUploading(false);
    }
  };

  const handleCancel = () => {
    setSelectedFile(null);
    setPreviewUrl(null);
    setKeywords('');
    setCaption('');
    if (fileInputRef.current) fileInputRef.current.value = '';
  };

  const handleStartEdit = (item) => {
    setEditingItem(item);
    setEditKeywords(item.keywords?.join(', ') || '');
    setEditCaption(item.caption || '');
  };

  const handleCancelEdit = () => {
    setEditingItem(null);
    setEditKeywords('');
    setEditCaption('');
  };

  const handleSaveEdit = async () => {
    if (!editKeywords.trim()) return;
    
    setIsSavingEdit(true);
    try {
      await onUpdate(editingItem.id, editKeywords, editCaption);
      setEditingItem(null);
      setEditKeywords('');
      setEditCaption('');
    } finally {
      setIsSavingEdit(false);
    }
  };

  return (
    <div className="bg-gray-800/30 rounded-xl border border-gray-700/50 p-3" data-testid="multimedia-section">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <Image className="w-4 h-4 text-blue-400" />
          <h3 className="text-sm font-medium text-white">Multimedia</h3>
          <span className="text-xs bg-gray-700/50 text-gray-400 px-1.5 py-0.5 rounded">
            {filteredItems.length}
          </span>
        </div>
        {!selectedFile && (
          <button
            onClick={() => fileInputRef.current?.click()}
            disabled={isLoading}
            className="flex items-center gap-1.5 px-2.5 py-1 bg-blue-500/20 hover:bg-blue-500/30 rounded-lg text-xs text-blue-400 transition-all disabled:opacity-50"
            data-testid="multimedia-add-btn"
          >
            <Plus className="w-3.5 h-3.5" />
            <span>Añadir</span>
          </button>
        )}
        <input
          ref={fileInputRef}
          type="file"
          accept="image/png,image/jpeg,image/jpg"
          onChange={handleFileSelect}
          className="hidden"
          data-testid="multimedia-file-input"
        />
      </div>
      
      {/* Upload form when file is selected */}
      {selectedFile && (
        <div className="mb-3 p-3 bg-gray-800/50 rounded-lg border border-gray-600" data-testid="multimedia-upload-form">
          <div className="flex gap-3">
            {previewUrl && (
              <img 
                src={previewUrl} 
                alt="Preview" 
                className="w-16 h-16 object-cover rounded-lg"
              />
            )}
            <div className="flex-1 space-y-2">
              <p className="text-xs text-gray-300 truncate">{selectedFile.name}</p>
              <input
                type="text"
                value={keywords}
                onChange={(e) => setKeywords(e.target.value)}
                placeholder="Palabras clave (separadas por coma)"
                className="w-full px-2 py-1.5 bg-gray-700 border border-gray-600 rounded text-xs text-white placeholder-gray-500 focus:border-blue-500 outline-none"
                data-testid="multimedia-keywords-input"
              />
              <input
                type="text"
                value={caption}
                onChange={(e) => setCaption(e.target.value)}
                placeholder="Pie de foto (ej: Vista del Partenón en Atenas)"
                className="w-full px-2 py-1.5 bg-gray-700 border border-gray-600 rounded text-xs text-white placeholder-gray-500 focus:border-blue-500 outline-none"
                data-testid="multimedia-caption-input"
              />
            </div>
          </div>
          <div className="flex justify-end gap-2 mt-3">
            <button
              onClick={handleCancel}
              className="px-3 py-1 text-xs text-gray-400 hover:text-white transition-all"
              data-testid="multimedia-cancel-btn"
            >
              Cancelar
            </button>
            <button
              onClick={handleUpload}
              disabled={!keywords.trim() || isUploading}
              className="flex items-center gap-1.5 px-3 py-1 bg-blue-500 hover:bg-blue-600 rounded text-xs text-white transition-all disabled:opacity-50 disabled:cursor-not-allowed"
              data-testid="multimedia-upload-btn"
            >
              {isUploading ? <Loader2 className="w-3 h-3 animate-spin" /> : <Upload className="w-3 h-3" />}
              <span>Subir</span>
            </button>
          </div>
        </div>
      )}
      
      {/* List of multimedia items - Compact grid (4 columns) */}
      {filteredItems.length === 0 && !selectedFile ? (
        <div className="text-center py-4 text-gray-500">
          <p className="text-xs">Sin multimedia</p>
        </div>
      ) : filteredItems.length > 0 && (
        <div className="grid grid-cols-4 gap-1.5 max-h-[200px] overflow-y-auto" data-testid="multimedia-list">
          {filteredItems.map(item => (
            <div
              key={item.id}
              className="relative group bg-gray-700 rounded overflow-hidden cursor-pointer w-[60px] h-[60px]"
              onClick={() => handleStartEdit(item)}
              data-testid={`multimedia-item-${item.id}`}
            >
              {item.image_thumb ? (
                <img 
                  src={`data:${item.mime_type || 'image/jpeg'};base64,${item.image_thumb}`}
                  alt={item.filename}
                  className="w-full h-full object-cover"
                />
              ) : (
                <div className="w-full h-full flex items-center justify-center">
                  <Image className="w-3 h-3 text-gray-500" />
                </div>
              )}
              {/* Hover overlay with keywords preview */}
              <div className="absolute inset-0 bg-black/70 opacity-0 group-hover:opacity-100 transition-all flex flex-col items-center justify-center p-0.5">
                <p className="text-[7px] text-gray-200 text-center line-clamp-2 leading-tight">
                  {item.keywords?.slice(0, 2).join(', ')}
                  {item.keywords?.length > 2 && '...'}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Edit Modal */}
      {editingItem && (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4" onClick={handleCancelEdit}>
          <div 
            className="bg-gray-900 rounded-xl border border-gray-700 max-w-md w-full overflow-hidden"
            onClick={e => e.stopPropagation()}
          >
            <div className="flex items-center justify-between p-4 border-b border-gray-700">
              <h3 className="text-sm font-semibold text-white">Editar Multimedia</h3>
              <button
                onClick={handleCancelEdit}
                className="p-1 hover:bg-gray-700 rounded-lg transition-colors"
              >
                <X className="w-4 h-4 text-gray-400" />
              </button>
            </div>
            
            <div className="p-4">
              {/* Image Preview */}
              <div className="flex justify-center mb-4">
                {editingItem.image_thumb ? (
                  <img 
                    src={`data:${editingItem.mime_type || 'image/jpeg'};base64,${editingItem.image_thumb}`}
                    alt={editingItem.filename}
                    className="max-w-[200px] max-h-[150px] object-contain rounded-lg"
                  />
                ) : (
                  <div className="w-32 h-24 bg-gray-700 rounded-lg flex items-center justify-center">
                    <Image className="w-8 h-8 text-gray-500" />
                  </div>
                )}
              </div>
              
              <p className="text-xs text-gray-400 mb-3 truncate">{editingItem.filename}</p>
              
              {/* Keywords Input */}
              <div className="mb-3">
                <label className="block text-xs text-gray-400 mb-1">Palabras clave *</label>
                <input
                  type="text"
                  value={editKeywords}
                  onChange={(e) => setEditKeywords(e.target.value)}
                  placeholder="Separadas por coma"
                  className="w-full px-3 py-2 bg-gray-800 border border-gray-600 rounded-lg text-sm text-white placeholder-gray-500 focus:border-blue-500 outline-none"
                  data-testid="edit-keywords-input"
                />
              </div>
              
              {/* Caption Input */}
              <div className="mb-4">
                <label className="block text-xs text-gray-400 mb-1">Pie de foto</label>
                <input
                  type="text"
                  value={editCaption}
                  onChange={(e) => setEditCaption(e.target.value)}
                  placeholder="Descripción de la imagen"
                  className="w-full px-3 py-2 bg-gray-800 border border-gray-600 rounded-lg text-sm text-white placeholder-gray-500 focus:border-blue-500 outline-none"
                  data-testid="edit-caption-input"
                />
              </div>
              
              {/* Buttons */}
              <div className="flex justify-between">
                {/* Delete Button - Left side */}
                <button
                  onClick={() => {
                    onDelete(editingItem.id);
                    handleCancelEdit();
                  }}
                  className="flex items-center gap-2 px-3 py-2 bg-red-500/10 hover:bg-red-500/20 border border-red-500/30 rounded-lg text-sm text-red-400 hover:text-red-300 transition-all"
                  data-testid="edit-delete-btn"
                >
                  <Trash2 className="w-4 h-4" />
                  <span>Eliminar</span>
                </button>
                
                {/* Save/Cancel - Right side */}
                <div className="flex gap-2">
                  <button
                    onClick={handleCancelEdit}
                    className="px-4 py-2 text-sm text-gray-400 hover:text-white transition-all"
                  >
                    Cancelar
                  </button>
                  <button
                    onClick={handleSaveEdit}
                    disabled={!editKeywords.trim() || isSavingEdit}
                    className="flex items-center gap-2 px-4 py-2 bg-blue-500 hover:bg-blue-600 rounded-lg text-sm text-white transition-all disabled:opacity-50 disabled:cursor-not-allowed"
                    data-testid="edit-save-btn"
                  >
                    {isSavingEdit ? (
                      <Loader2 className="w-4 h-4 animate-spin" />
                    ) : (
                      <Save className="w-4 h-4" />
                    )}
                    <span>Guardar</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// Instructions Editor Section (renamed from Prompt)
const InstructionsSection = ({ 
  prompt, 
  isUnlocked, 
  onUnlockRequest, 
  onSave,
  isSaving 
}) => {
  const [text, setText] = useState(prompt?.prompt_text || '');
  const [hasChanges, setHasChanges] = useState(false);

  useEffect(() => {
    setText(prompt?.prompt_text || '');
    setHasChanges(false);
  }, [prompt]);

  const handleChange = (e) => {
    setText(e.target.value);
    setHasChanges(e.target.value !== prompt?.prompt_text);
  };

  const handleSave = () => {
    if (prompt && hasChanges) {
      onSave(prompt.id, text);
      setHasChanges(false);
    }
  };

  if (!prompt) {
    return (
      <div className="bg-gray-800/30 rounded-xl border border-gray-700/50 p-3 text-center text-gray-500">
        <p className="text-xs">Sin instrucciones configuradas</p>
      </div>
    );
  }

  return (
    <div className="bg-gray-800/30 rounded-xl border border-gray-700/50 p-3 flex flex-col">
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-2">
          <Sparkles className="w-4 h-4 text-blue-400" />
          <h3 className="text-sm font-medium text-white">Instrucciones</h3>
        </div>
        {isUnlocked ? (
          <button
            onClick={handleSave}
            disabled={!hasChanges || isSaving}
            className={`flex items-center gap-1.5 px-2.5 py-1 rounded-lg text-xs transition-all ${
              hasChanges && !isSaving
                ? 'bg-blue-500 hover:bg-blue-600 text-white'
                : 'bg-gray-700/50 text-gray-500 cursor-not-allowed'
            }`}
          >
            {isSaving ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Save className="w-3.5 h-3.5" />}
            <span>Guardar</span>
          </button>
        ) : (
          <button
            onClick={onUnlockRequest}
            className="flex items-center gap-1.5 px-2.5 py-1 bg-gray-700/50 hover:bg-gray-700 rounded-lg text-xs text-gray-300 transition-all"
          >
            <Lock className="w-3.5 h-3.5" />
            <span>Editar</span>
          </button>
        )}
      </div>
      
      {isUnlocked ? (
        <textarea
          value={text}
          onChange={handleChange}
          className="w-full p-2 bg-gray-800/50 border border-gray-700/50 rounded-lg text-gray-200 text-xs font-mono resize-none focus:border-blue-500/50 focus:ring-1 focus:ring-blue-500/50 outline-none h-32"
        />
      ) : (
        <div className="relative h-32">
          <div className="absolute inset-0 p-2 bg-gray-800/50 border border-gray-700/50 rounded-lg text-gray-500 text-xs font-mono overflow-hidden">
            <div className="blur-sm select-none line-clamp-6">
              {text.substring(0, 300)}...
            </div>
          </div>
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="text-center">
              <Lock className="w-4 h-4 text-gray-600 mx-auto mb-1" />
              <p className="text-xs text-gray-500">PIN requerido</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// Advanced Configuration Section - Display only (info del agente)
const AdvancedConfigSection = ({ config }) => {
  // Format token count for display
  const formatTokens = (count) => {
    if (count >= 1000000) return `${(count / 1000000).toFixed(1)}M`;
    if (count >= 1000) return `${(count / 1000).toFixed(1)}K`;
    return count?.toString() || '0';
  };

  return (
    <div className="bg-gray-800/30 rounded-xl border border-gray-700/50 p-3" data-testid="advanced-config-section">
      <div className="flex items-center gap-2 mb-3">
        <Bot className="w-4 h-4 text-purple-400" />
        <h3 className="text-sm font-medium text-white">Información del Agente</h3>
      </div>

      {/* Model Info */}
      <div className="space-y-2">
        <div className="flex items-center justify-between p-2 bg-gray-800/50 rounded-lg border border-gray-700/30">
          <span className="text-xs text-gray-400">Modelo de IA</span>
          <span className="text-xs font-medium text-purple-300">{config?.model_name || 'gpt-4o-mini'}</span>
        </div>
        
        <div className="flex items-center justify-between p-2 bg-gray-800/50 rounded-lg border border-gray-700/30">
          <span className="text-xs text-gray-400">Tokens usados</span>
          <span className="text-xs font-medium text-gray-300">{formatTokens(config?.total_tokens_used || 0)}</span>
        </div>
      </div>
    </div>
  );
};

// Learning Plan Editor Section - Edit topics and subtopics
const LearningPlanEditor = ({ subjectId, subjectName }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [outline, setOutline] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [editText, setEditText] = useState('');
  const [saveStatus, setSaveStatus] = useState(null);

  useEffect(() => {
    loadOutline();
  }, [subjectId]);

  const loadOutline = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(`${API_BASE}/api/learning-plan/${subjectId}`);
      if (response.ok) {
        const data = await response.json();
        setOutline(data.outline || []);
        // Convert to editable text format
        setEditText(outlineToText(data.outline || []));
      }
    } catch (error) {
      console.error('Error loading outline:', error);
    }
    setIsLoading(false);
  };

  const outlineToText = (outlineData) => {
    let text = '';
    outlineData.forEach((section, i) => {
      text += `${toRoman(i + 1)}. ${section.title}\n`;
      (section.subtopics || []).forEach(sub => {
        text += `   - ${sub.title}\n`;
      });
    });
    return text;
  };

  const toRoman = (num) => {
    const romanNumerals = ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X', 'XI', 'XII'];
    return romanNumerals[num - 1] || num.toString();
  };

  const textToOutline = (text) => {
    const lines = text.split('\n').filter(l => l.trim());
    const newOutline = [];
    let currentSection = null;
    let sectionId = 0;

    lines.forEach(line => {
      const trimmed = line.trim();
      
      // Check if it's a main section (starts with Roman numeral or number followed by period)
      const sectionMatch = trimmed.match(/^(?:([IVXLC]+)|(\d+))\.\s*(.+)/);
      
      if (sectionMatch && !line.startsWith('   ') && !line.startsWith('\t') && !line.startsWith('-')) {
        sectionId++;
        currentSection = {
          id: `sec-${sectionId}`,
          title: sectionMatch[3].trim(),
          type: 'section',
          subtopics: []
        };
        newOutline.push(currentSection);
      } else if ((line.startsWith('   ') || line.startsWith('\t') || trimmed.startsWith('-')) && currentSection) {
        // It's a subtopic
        const subtopicTitle = trimmed.replace(/^-\s*/, '').trim();
        if (subtopicTitle) {
          currentSection.subtopics.push({
            id: `${currentSection.id}-sub-${currentSection.subtopics.length + 1}`,
            title: subtopicTitle,
            type: 'subtopic'
          });
        }
      }
    });

    return newOutline;
  };

  const handleSave = async () => {
    setIsLoading(true);
    setSaveStatus(null);
    
    const newOutline = textToOutline(editText);
    
    try {
      const response = await fetch(`${API_BASE}/api/learning-plan/${subjectId}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ outline: newOutline })
      });
      
      if (response.ok) {
        setOutline(newOutline);
        setIsEditing(false);
        setSaveStatus('success');
        setTimeout(() => setSaveStatus(null), 3000);
      } else {
        setSaveStatus('error');
      }
    } catch (error) {
      console.error('Error saving outline:', error);
      setSaveStatus('error');
    }
    
    setIsLoading(false);
  };

  return (
    <div className="bg-gray-800/30 rounded-xl border border-gray-700/50 p-3" data-testid="learning-plan-editor">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <BookOpen className="w-4 h-4 text-amber-400" />
          <h3 className="text-sm font-medium text-white">Plan de Aprendizaje</h3>
          <span className="text-xs bg-gray-700/50 text-gray-400 px-1.5 py-0.5 rounded">
            {outline.length} temas
          </span>
        </div>
        <button
          onClick={() => setIsEditing(!isEditing)}
          className={`flex items-center gap-1.5 px-2.5 py-1 rounded-lg text-xs font-medium transition-colors ${
            isEditing 
              ? 'bg-gray-600 text-white' 
              : 'bg-amber-500/20 hover:bg-amber-500/30 text-amber-300 border border-amber-500/30'
          }`}
        >
          {isEditing ? <X className="w-3 h-3" /> : <Pencil className="w-3 h-3" />}
          {isEditing ? 'Cancelar' : 'Editar'}
        </button>
      </div>

      {saveStatus === 'success' && (
        <div className="mb-3 p-2 bg-emerald-500/20 border border-emerald-500/30 rounded-lg">
          <p className="text-xs text-emerald-300 flex items-center gap-2">
            <CheckCircle2 className="w-3.5 h-3.5" />
            Plan de aprendizaje guardado correctamente
          </p>
        </div>
      )}

      {isEditing ? (
        <div className="space-y-3">
          <div className="p-2 bg-gray-900/50 rounded-lg border border-gray-700/30">
            <p className="text-xs text-gray-400 mb-2">
              Formato: Usa números romanos (I., II., III.) para secciones principales.
              Usa guiones (-) con indentación para subtemas.
            </p>
            <textarea
              value={editText}
              onChange={(e) => setEditText(e.target.value)}
              className="w-full h-64 px-3 py-2 bg-gray-800 border border-gray-600 rounded-lg text-sm text-white placeholder-gray-500 focus:outline-none focus:border-amber-500 font-mono whitespace-pre-wrap break-words overflow-x-hidden"
              placeholder={`I. Introducción a la Filosofía\n   - ¿Qué es la filosofía?\n   - Ramas de la filosofía\nII. Filosofía Antigua\n   - Sócrates y el método mayéutico`}
              style={{ resize: 'vertical' }}
            />
          </div>
          <button
            onClick={handleSave}
            disabled={isLoading}
            className="w-full flex items-center justify-center gap-2 px-4 py-2 bg-amber-500 hover:bg-amber-600 text-white text-sm font-medium rounded-lg transition-colors disabled:opacity-50"
          >
            {isLoading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />}
            Guardar Plan
          </button>
        </div>
      ) : (
        <div className="space-y-1">
          {outline.length === 0 ? (
            <div className="text-center py-4 text-gray-500">
              <BookOpen className="w-6 h-6 mx-auto mb-2 opacity-50" />
              <p className="text-xs">No hay plan de aprendizaje definido</p>
              <p className="text-[10px] opacity-70">Haz clic en "Editar" para crear uno</p>
            </div>
          ) : (
            outline.map((section, idx) => (
              <div key={section.id} className="text-xs">
                <div className="flex items-start gap-2 py-1.5 text-gray-200">
                  <span className="text-amber-400 font-medium flex-shrink-0">{toRoman(idx + 1)}.</span>
                  <span className="font-medium break-words">{section.title}</span>
                </div>
                {section.subtopics?.map(sub => (
                  <div key={sub.id} className="flex items-start gap-2 py-1 pl-6 text-gray-400">
                    <span className="flex-shrink-0">-</span>
                    <span className="break-words">{sub.title}</span>
                  </div>
                ))}
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
};

// Diagnostic Section - Health check for agent configuration
const DiagnosticSection = ({ subjectId, subjectName }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [diagnosticResult, setDiagnosticResult] = useState(null);
  const [showFullPrompt, setShowFullPrompt] = useState(false);
  const [fullPromptData, setFullPromptData] = useState(null);

  const runDiagnostic = async () => {
    setIsLoading(true);
    setDiagnosticResult(null);
    
    try {
      const response = await fetch(`${API_BASE}/api/debug/health-check/${subjectId}?role=student`);
      if (response.ok) {
        const data = await response.json();
        setDiagnosticResult(data);
      } else {
        setDiagnosticResult({ 
          overall_status: 'ERROR', 
          checks: [{ component: 'API', status: '✗ ERROR', detail: 'No se pudo conectar con el servidor' }] 
        });
      }
    } catch (error) {
      setDiagnosticResult({ 
        overall_status: 'ERROR', 
        checks: [{ component: 'API', status: '✗ ERROR', detail: error.message }] 
      });
    }
    
    setIsLoading(false);
  };

  const viewFullPrompt = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(`${API_BASE}/api/debug/system-prompt/${subjectId}?role=student`);
      if (response.ok) {
        const data = await response.json();
        setFullPromptData(data);
        setShowFullPrompt(true);
      }
    } catch (error) {
      console.error('Error fetching full prompt:', error);
    }
    setIsLoading(false);
  };

  const getStatusIcon = (status) => {
    if (status.includes('✓') || status.includes('OK')) {
      return <CheckCircle2 className="w-4 h-4 text-emerald-400" />;
    } else if (status.includes('⚠') || status.includes('WARNING') || status.includes('CORTO')) {
      return <AlertCircle className="w-4 h-4 text-amber-400" />;
    } else if (status.includes('✗') || status.includes('ERROR') || status.includes('FALTANTE')) {
      return <AlertCircle className="w-4 h-4 text-red-400" />;
    } else {
      return <Info className="w-4 h-4 text-gray-400" />;
    }
  };

  const getOverallStatusColor = (status) => {
    switch (status) {
      case 'OK': return 'text-emerald-400 bg-emerald-400/10 border-emerald-400/30';
      case 'WARNING': return 'text-amber-400 bg-amber-400/10 border-amber-400/30';
      case 'ERROR': return 'text-red-400 bg-red-400/10 border-red-400/30';
      default: return 'text-gray-400 bg-gray-400/10 border-gray-400/30';
    }
  };

  return (
    <div className="bg-gray-800/30 rounded-xl border border-gray-700/50 p-3" data-testid="diagnostic-section">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <Activity className="w-4 h-4 text-cyan-400" />
          <h3 className="text-sm font-medium text-white">Diagnóstico del Agente</h3>
        </div>
        <button
          onClick={runDiagnostic}
          disabled={isLoading}
          className="flex items-center gap-1.5 px-3 py-1.5 bg-cyan-500/20 hover:bg-cyan-500/30 text-cyan-300 text-xs font-medium rounded-lg border border-cyan-500/30 transition-colors disabled:opacity-50"
          data-testid="run-diagnostic-btn"
        >
          {isLoading ? (
            <Loader2 className="w-3 h-3 animate-spin" />
          ) : (
            <Activity className="w-3 h-3" />
          )}
          Verificar
        </button>
      </div>

      {/* Diagnostic Results */}
      {diagnosticResult && (
        <div className="space-y-2">
          {/* Overall Status */}
          <div className={`flex items-center justify-between p-2 rounded-lg border ${getOverallStatusColor(diagnosticResult.overall_status)}`}>
            <span className="text-xs font-medium">Estado General</span>
            <span className="text-xs font-bold">{diagnosticResult.overall_status}</span>
          </div>

          {/* Individual Checks */}
          <div className="space-y-1.5">
            {diagnosticResult.checks?.map((check, index) => (
              <div 
                key={index}
                className="flex items-start gap-2 p-2 bg-gray-800/50 rounded-lg border border-gray-700/30"
              >
                {getStatusIcon(check.status)}
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between">
                    <span className="text-xs font-medium text-white">{check.component}</span>
                    <span className="text-xs text-gray-400">{check.status.replace(/[✓✗⚠-]/g, '').trim()}</span>
                  </div>
                  <p className="text-xs text-gray-500 truncate">{check.detail}</p>
                </div>
              </div>
            ))}
          </div>

          {/* View Full Prompt Button */}
          <button
            onClick={viewFullPrompt}
            disabled={isLoading}
            className="w-full mt-2 flex items-center justify-center gap-1.5 px-3 py-2 bg-gray-700/50 hover:bg-gray-700/70 text-gray-300 text-xs font-medium rounded-lg border border-gray-600/30 transition-colors"
            data-testid="view-full-prompt-btn"
          >
            <FileText className="w-3 h-3" />
            Ver Prompt Completo
          </button>
        </div>
      )}

      {/* Initial State */}
      {!diagnosticResult && !isLoading && (
        <p className="text-xs text-gray-500 text-center py-2">
          Haz clic en "Verificar" para comprobar que las instrucciones y documentos de conocimiento están configurados correctamente.
        </p>
      )}

      {/* Full Prompt Modal */}
      {showFullPrompt && fullPromptData && (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4" onClick={() => setShowFullPrompt(false)}>
          <div 
            className="bg-gray-900 rounded-xl border border-gray-700 max-w-3xl w-full max-h-[80vh] overflow-hidden"
            onClick={e => e.stopPropagation()}
          >
            <div className="flex items-center justify-between p-4 border-b border-gray-700">
              <div>
                <h3 className="text-lg font-semibold text-white">Prompt Completo</h3>
                <p className="text-xs text-gray-400">{subjectName} • {fullPromptData.diagnostics?.total_chars?.toLocaleString()} caracteres</p>
              </div>
              <button
                onClick={() => setShowFullPrompt(false)}
                className="p-1 hover:bg-gray-700 rounded-lg transition-colors"
              >
                <X className="w-5 h-5 text-gray-400" />
              </button>
            </div>
            
            {/* Components Summary */}
            <div className="p-4 border-b border-gray-700 bg-gray-800/50">
              <h4 className="text-xs font-medium text-gray-400 mb-2">Componentes Incluidos:</h4>
              <div className="flex flex-wrap gap-2">
                {fullPromptData.diagnostics?.components?.instructions?.included && (
                  <span className="px-2 py-1 bg-emerald-500/20 text-emerald-300 text-xs rounded-full border border-emerald-500/30">
                    ✓ Instrucciones ({fullPromptData.diagnostics.components.instructions.chars} chars)
                  </span>
                )}
                {fullPromptData.diagnostics?.components?.rag?.included && (
                  <span className="px-2 py-1 bg-blue-500/20 text-blue-300 text-xs rounded-full border border-blue-500/30">
                    ✓ RAG ({fullPromptData.diagnostics.components.rag.doc_count} docs)
                  </span>
                )}
                {fullPromptData.diagnostics?.components?.length_control?.included && (
                  <span className="px-2 py-1 bg-purple-500/20 text-purple-300 text-xs rounded-full border border-purple-500/30">
                    ✓ Control de Longitud
                  </span>
                )}
              </div>
            </div>

            {/* Full Prompt Text */}
            <div className="p-4 overflow-y-auto max-h-[50vh]">
              <pre className="text-xs text-gray-300 whitespace-pre-wrap font-mono bg-gray-800/50 p-4 rounded-lg border border-gray-700">
                {fullPromptData.full_prompt}
              </pre>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// RAG Chunks Viewer Section - Shows semantic search chunks
const ChunksViewerSection = ({ subjectId, subjectName }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [ragStatus, setRagStatus] = useState(null);
  const [chunks, setChunks] = useState([]);
  const [showChunks, setShowChunks] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState(null);
  const [isSearching, setIsSearching] = useState(false);

  const loadRagStatus = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(`${API_BASE}/api/editor/rag-status`);
      if (response.ok) {
        const data = await response.json();
        setRagStatus(data);
      }
    } catch (error) {
      console.error('Error loading RAG status:', error);
    }
    setIsLoading(false);
  };

  const loadChunks = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(`${API_BASE}/api/editor/rag-chunks/${subjectId}`);
      if (response.ok) {
        const data = await response.json();
        setChunks(data.chunks || []);
        setShowChunks(true);
      }
    } catch (error) {
      console.error('Error loading chunks:', error);
    }
    setIsLoading(false);
  };

  const testSemanticSearch = async () => {
    if (!searchQuery.trim()) return;
    
    setIsSearching(true);
    setSearchResults(null);
    try {
      const response = await fetch(`${API_BASE}/api/editor/rag-search/${subjectId}?query=${encodeURIComponent(searchQuery)}`);
      if (response.ok) {
        const data = await response.json();
        setSearchResults(data);
      }
    } catch (error) {
      console.error('Error searching:', error);
    }
    setIsSearching(false);
  };

  const reindexDocuments = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(`${API_BASE}/api/editor/rag-docs/reindex`, {
        method: 'POST'
      });
      if (response.ok) {
        const data = await response.json();
        alert(`Reindexación completada: ${data.processed} documentos, ${data.total_chunks} chunks creados`);
        loadRagStatus();
      }
    } catch (error) {
      console.error('Error reindexing:', error);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    loadRagStatus();
  }, [subjectId]);

  const subjectStatus = ragStatus?.subjects?.[subjectId];

  return (
    <div className="bg-gray-800/30 rounded-xl border border-gray-700/50 p-3" data-testid="chunks-viewer-section">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <Sparkles className="w-4 h-4 text-violet-400" />
          <h3 className="text-sm font-medium text-white">RAG Semántico - Chunks</h3>
        </div>
        <div className="flex items-center gap-2">
          <button
            onClick={reindexDocuments}
            disabled={isLoading}
            className="flex items-center gap-1.5 px-2 py-1 bg-amber-500/20 hover:bg-amber-500/30 text-amber-300 text-xs font-medium rounded-lg border border-amber-500/30 transition-colors disabled:opacity-50"
            data-testid="reindex-btn"
          >
            {isLoading ? <Loader2 className="w-3 h-3 animate-spin" /> : <Sparkles className="w-3 h-3" />}
            Reindexar
          </button>
          <button
            onClick={loadChunks}
            disabled={isLoading}
            className="flex items-center gap-1.5 px-2 py-1 bg-violet-500/20 hover:bg-violet-500/30 text-violet-300 text-xs font-medium rounded-lg border border-violet-500/30 transition-colors disabled:opacity-50"
            data-testid="view-chunks-btn"
          >
            {isLoading ? <Loader2 className="w-3 h-3 animate-spin" /> : <FileText className="w-3 h-3" />}
            Ver Chunks
          </button>
        </div>
      </div>

      {/* Status Summary */}
      {ragStatus && (
        <div className="mb-3 p-2 bg-gray-900/50 rounded-lg border border-gray-700/30">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <div className="text-center">
                <div className="text-lg font-bold text-violet-400">{subjectStatus?.chunks || 0}</div>
                <div className="text-xs text-gray-500">Chunks</div>
              </div>
              <div className="text-center">
                <div className="text-lg font-bold text-blue-400">{subjectStatus?.documents || 0}</div>
                <div className="text-xs text-gray-500">Documentos</div>
              </div>
              <div className="text-center">
                <div className={`text-lg font-bold ${subjectStatus?.indexed ? 'text-emerald-400' : 'text-amber-400'}`}>
                  {subjectStatus?.indexed ? '✓' : '○'}
                </div>
                <div className="text-xs text-gray-500">Indexado</div>
              </div>
            </div>
            <div className="text-xs text-gray-400">
              Búsqueda semántica: {ragStatus.semantic_search_enabled ? 
                <span className="text-emerald-400">Activa</span> : 
                <span className="text-red-400">Inactiva</span>
              }
            </div>
          </div>
        </div>
      )}

      {/* Semantic Search Test */}
      <div className="mb-3 p-2 bg-gray-900/50 rounded-lg border border-gray-700/30">
        <div className="text-xs text-gray-400 mb-2">🔍 Probar búsqueda semántica:</div>
        <div className="flex gap-2">
          <input
            type="text"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && testSemanticSearch()}
            placeholder="Ej: ¿Qué es el arte románico?"
            className="flex-1 px-2 py-1.5 bg-gray-800 border border-gray-600 rounded-lg text-xs text-white placeholder-gray-500 focus:outline-none focus:border-violet-500"
            data-testid="semantic-search-input"
          />
          <button
            onClick={testSemanticSearch}
            disabled={isSearching || !searchQuery.trim()}
            className="px-3 py-1.5 bg-violet-500/20 hover:bg-violet-500/30 text-violet-300 text-xs font-medium rounded-lg border border-violet-500/30 transition-colors disabled:opacity-50"
            data-testid="semantic-search-btn"
          >
            {isSearching ? <Loader2 className="w-3 h-3 animate-spin" /> : 'Buscar'}
          </button>
        </div>

        {/* Search Results */}
        {searchResults && (
          <div className="mt-3 space-y-2">
            <div className="text-xs text-gray-400">
              Top {searchResults.results?.length || 0} chunks más relevantes:
            </div>
            {searchResults.results?.map((result, idx) => (
              <div key={idx} className="p-2 bg-gray-800/50 rounded-lg border border-gray-700/50">
                <div className="flex items-center justify-between mb-1">
                  <span className="text-xs font-medium text-violet-400">#{idx + 1}</span>
                  <span className="text-xs text-gray-500">
                    Similitud: <span className="text-emerald-400 font-mono">{(result.similarity * 100).toFixed(1)}%</span>
                  </span>
                </div>
                <p className="text-xs text-gray-300 line-clamp-3">{result.content}</p>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Chunks List Modal */}
      {showChunks && (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4" onClick={() => setShowChunks(false)}>
          <div 
            className="bg-gray-900 rounded-xl border border-gray-700 max-w-4xl w-full max-h-[80vh] overflow-hidden shadow-2xl"
            onClick={e => e.stopPropagation()}
          >
            {/* Header */}
            <div className="flex items-center justify-between p-4 border-b border-gray-700">
              <div className="flex items-center gap-3">
                <Sparkles className="w-5 h-5 text-violet-400" />
                <div>
                  <h3 className="text-base font-semibold text-white">Chunks de {subjectName}</h3>
                  <p className="text-xs text-gray-400">{chunks.length} fragmentos indexados</p>
                </div>
              </div>
              <button
                onClick={() => setShowChunks(false)}
                className="p-1 hover:bg-gray-700 rounded-lg transition-colors"
              >
                <X className="w-5 h-5 text-gray-400" />
              </button>
            </div>

            {/* Chunks Grid */}
            <div className="p-4 overflow-y-auto max-h-[60vh]">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                {chunks.map((chunk, idx) => (
                  <div 
                    key={chunk.id || idx} 
                    className="p-3 bg-gray-800/50 rounded-lg border border-gray-700/50 hover:border-violet-500/30 transition-colors"
                  >
                    <div className="flex items-center justify-between mb-2">
                      <span className="px-2 py-0.5 bg-violet-500/20 text-violet-300 text-xs font-medium rounded-full">
                        Chunk #{chunk.chunk_index}
                      </span>
                      <span className="text-xs text-gray-500">
                        {chunk.content?.length || 0} chars
                      </span>
                    </div>
                    <p className="text-xs text-gray-300 line-clamp-4 leading-relaxed">
                      {chunk.content}
                    </p>
                    {chunk.embedding && (
                      <div className="mt-2 text-xs text-gray-500">
                        Embedding: [{chunk.embedding.slice(0, 3).map(v => v.toFixed(3)).join(', ')}, ...] 
                        <span className="text-gray-600">({chunk.embedding.length}d)</span>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// Main Component
const MisClasesView = () => {
  const [selectedAgent, setSelectedAgent] = useState(AGENT_PROFILES[0]);
  const [subjectData, setSubjectData] = useState({}); // Dynamic subject data from API
  const [prompts, setPrompts] = useState({});
  const [ragDocs, setRagDocs] = useState([]);
  const [multimedia, setMultimedia] = useState([]);
  const [agentConfigs, setAgentConfigs] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [isPromptUnlocked, setIsPromptUnlocked] = useState(false);
  const [showPinInput, setShowPinInput] = useState(false);
  const [pinError, setPinError] = useState(null);
  const [editorToken, setEditorToken] = useState(null);
  const [verifiedPin, setVerifiedPin] = useState(null); // Store verified PIN for analytics
  const [saveSuccess, setSaveSuccess] = useState(false);
  
  // Analytics Panel state
  const [showAnalyticsPanel, setShowAnalyticsPanel] = useState(false);
  const [isAnalyticsUnlocked, setIsAnalyticsUnlocked] = useState(false);
  const [showAnalyticsPinInput, setShowAnalyticsPinInput] = useState(false);
  const [analyticsPinError, setAnalyticsPinError] = useState(null);
  const [analyticsPin, setAnalyticsPin] = useState(null);
  
  // Alert Modal state
  const [alertModal, setAlertModal] = useState({
    isOpen: false,
    title: '',
    message: '',
    type: 'error'
  });

  // Confirm Modal state
  const [confirmModal, setConfirmModal] = useState({
    isOpen: false,
    title: '',
    message: '',
    type: 'warning',
    onConfirm: () => {}
  });

  const showAlert = (title, message, type = 'error') => {
    setAlertModal({ isOpen: true, title, message, type });
  };

  const closeAlert = () => {
    setAlertModal(prev => ({ ...prev, isOpen: false }));
  };

  const showConfirm = (title, message, onConfirm, type = 'warning') => {
    setConfirmModal({ isOpen: true, title, message, type, onConfirm });
  };

  const closeConfirm = () => {
    setConfirmModal(prev => ({ ...prev, isOpen: false }));
  };

  // Load data
  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    setIsLoading(true);
    try {
      const docsResponse = await fetch(`${API_BASE}/api/editor/rag-docs`);
      if (docsResponse.ok) {
        const docsData = await docsResponse.json();
        setRagDocs(docsData.documents || []);
      }
      
      const promptsResponse = await fetch(`${API_BASE}/api/prompts`);
      if (promptsResponse.ok) {
        const promptsData = await promptsResponse.json();
        const promptsMap = {};
        promptsData.forEach(p => {
          promptsMap[p.id] = p;
        });
        setPrompts(promptsMap);
      }

      const multimediaResponse = await fetch(`${API_BASE}/api/editor/multimedia`);
      if (multimediaResponse.ok) {
        const multimediaData = await multimediaResponse.json();
        setMultimedia(multimediaData.items || []);
      }

      // Load agent configurations
      const configsResponse = await fetch(`${API_BASE}/api/editor/agent-configs`);
      if (configsResponse.ok) {
        const configsData = await configsResponse.json();
        const configsMap = {};
        (configsData.configs || []).forEach(c => {
          configsMap[c.subject_id] = c;
        });
        setAgentConfigs(configsMap);
      }

      // Load subject data (names, descriptions from DB)
      const subjectsResponse = await fetch(`${API_BASE}/api/subjects`);
      if (subjectsResponse.ok) {
        const subjectsData = await subjectsResponse.json();
        const subjectsMap = {};
        subjectsData.forEach(s => {
          subjectsMap[s.id] = s;
        });
        setSubjectData(subjectsMap);
      }
    } catch (err) {
      console.error('Error loading data:', err);
    } finally {
      setIsLoading(false);
    }
  };

  // Update subject name/description
  const handleUpdateSubject = async (subjectId, updates) => {
    try {
      const response = await fetch(`${API_BASE}/api/subjects/${subjectId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(updates)
      });
      
      if (!response.ok) throw new Error('Failed to update subject');
      
      const result = await response.json();
      
      // Update local state
      setSubjectData(prev => ({
        ...prev,
        [subjectId]: result.subject
      }));
      
      showAlert('Actualizado', 'Asignatura actualizada correctamente', 'success');
    } catch (error) {
      console.error('Error updating subject:', error);
      showAlert('Error', 'No se pudo actualizar la asignatura', 'error');
      throw error;
    }
  };

  const handlePinSubmit = async (pin) => {
    setPinError(null);
    try {
      const response = await fetch(`${API_BASE}/api/editor/verify-pin`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ pin, role: 'teacher' })
      });
      
      const data = await response.json();
      
      if (data.success) {
        setEditorToken(data.token);
        setVerifiedPin(pin); // Store PIN for analytics
        setIsPromptUnlocked(true);
        setShowPinInput(false);
      } else {
        setPinError(data.message || 'PIN incorrecto');
      }
    } catch (err) {
      setPinError('Error de conexión');
    }
  };

  // Handle Analytics PIN submission
  const handleAnalyticsPinSubmit = async (pin) => {
    setAnalyticsPinError(null);
    try {
      const response = await fetch(`${API_BASE}/api/editor/verify-pin`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ pin, role: 'teacher' })
      });
      
      const data = await response.json();
      
      if (data.success) {
        setAnalyticsPin(pin);
        setIsAnalyticsUnlocked(true);
        setShowAnalyticsPinInput(false);
      } else {
        setAnalyticsPinError(data.message || 'PIN incorrecto');
      }
    } catch (err) {
      setAnalyticsPinError('Error de conexión');
    }
  };

  const handleSavePrompt = async (promptId, promptText) => {
    if (!editorToken) return;
    
    setIsSaving(true);
    try {
      const response = await fetch(`${API_BASE}/api/editor/prompts/${promptId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${editorToken}`
        },
        body: JSON.stringify({ prompt_text: promptText })
      });
      
      if (response.ok) {
        await loadData();
        setSaveSuccess(true);
        setTimeout(() => setSaveSuccess(false), 3000);
      }
    } catch (err) {
      console.error('Error saving prompt:', err);
    } finally {
      setIsSaving(false);
    }
  };

  const handleUploadDoc = async (file, subjectId) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('subject_id', subjectId);
    formData.append('role', 'student');
    
    try {
      const response = await fetch(`${API_BASE}/api/editor/rag-docs`, {
        method: 'POST',
        body: formData
      });
      
      if (response.ok) {
        await loadData();
      }
    } catch (err) {
      console.error('Error uploading doc:', err);
    }
  };

  const handleDeleteDoc = async (docId) => {
    showConfirm(
      'Eliminar documento',
      '¿Estás seguro de que deseas eliminar este documento? Esta acción no se puede deshacer.',
      async () => {
        try {
          const response = await fetch(`${API_BASE}/api/editor/rag-docs/${docId}`, {
            method: 'DELETE'
          });
          
          if (response.ok) {
            await loadData();
          }
        } catch (err) {
          console.error('Error deleting doc:', err);
        }
      },
      'danger'
    );
  };

  const handleUploadMultimedia = async (file, subjectId, keywords, caption = '') => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('subject_id', subjectId);
    formData.append('keywords', keywords);
    formData.append('caption', caption);
    
    try {
      const response = await fetch(`${API_BASE}/api/editor/multimedia`, {
        method: 'POST',
        body: formData
      });
      
      if (response.ok) {
        await loadData();
      } else {
        const error = await response.json();
        console.error('Error uploading multimedia:', error);
        showAlert('Error al subir imagen', error.detail || 'No se pudo subir la imagen. Inténtalo de nuevo.', 'error');
      }
    } catch (err) {
      console.error('Error uploading multimedia:', err);
      showAlert('Error de conexión', 'No se pudo conectar con el servidor. Verifica tu conexión e inténtalo de nuevo.', 'error');
    }
  };

  const handleDeleteMultimedia = async (itemId) => {
    try {
      const response = await fetch(`${API_BASE}/api/editor/multimedia/${itemId}`, {
        method: 'DELETE'
      });
      
      if (response.ok) {
        await loadData();
      }
    } catch (err) {
      console.error('Error deleting multimedia:', err);
    }
  };

  const handleUpdateMultimedia = async (itemId, keywords, caption) => {
    const formData = new FormData();
    formData.append('keywords', keywords);
    formData.append('caption', caption || '');
    
    try {
      const response = await fetch(`${API_BASE}/api/editor/multimedia/${itemId}`, {
        method: 'PUT',
        body: formData
      });
      
      if (response.ok) {
        await loadData();
      } else {
        const error = await response.json();
        console.error('Error updating multimedia:', error);
        showAlert('Error al actualizar', error.detail || 'No se pudo actualizar la imagen. Inténtalo de nuevo.', 'error');
      }
    } catch (err) {
      console.error('Error updating multimedia:', err);
      showAlert('Error de conexión', 'No se pudo conectar con el servidor. Verifica tu conexión e inténtalo de nuevo.', 'error');
    }
  };

  const handleUpdateAgentConfig = async (subjectId, updates) => {
    try {
      const response = await fetch(`${API_BASE}/api/editor/agent-config/${subjectId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(updates)
      });
      
      if (response.ok) {
        const updatedConfig = await response.json();
        setAgentConfigs(prev => ({
          ...prev,
          [subjectId]: updatedConfig
        }));
      }
    } catch (err) {
      console.error('Error updating agent config:', err);
    }
  };

  const getCurrentPrompt = () => {
    return prompts[selectedAgent.promptId];
  };

  const getRagCount = (agentId) => {
    // For default agents, use "default" as subject_id in the database
    const subjectId = agentId.startsWith('default-') ? 'default' : agentId;
    return ragDocs.filter(d => d.subject_id === subjectId).length;
  };

  // Get the subject_id for RAG documents (map default-student/default-teacher to "default")
  const getSubjectIdForRag = (agentId) => {
    return agentId.startsWith('default-') ? 'default' : agentId;
  };

  // Get current agent configuration
  const getCurrentAgentConfig = () => {
    const subjectId = getSubjectIdForRag(selectedAgent.id);
    return agentConfigs[subjectId] || { max_tokens: 1000, temperature: 0.7, model_name: 'gpt-4o-mini', total_tokens_used: 0 };
  };

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-full">
        <Loader2 className="w-6 h-6 text-blue-500 animate-spin" />
      </div>
    );
  }

  return (
    <div className="flex flex-col h-full p-4 overflow-hidden" data-testid="mis-clases-view">
      {/* Header */}
      <div className="flex-shrink-0 mb-4">
        <div className="flex items-center gap-2 mb-1">
          <BookOpen className="w-5 h-5 text-blue-400" />
          <h1 className="text-lg font-semibold text-white">Mis Clases</h1>
        </div>
        <p className="text-xs text-gray-500">
          Gestiona cursos, grupos, alumnos y agentes
        </p>
      </div>

      {/* Success Message */}
      {saveSuccess && (
        <div className="flex-shrink-0 flex items-center gap-2 mb-3 px-3 py-1.5 bg-green-500/10 border border-green-500/30 rounded-lg text-green-400 text-xs">
          <CheckCircle className="w-3.5 h-3.5" />
          <span>Guardado</span>
        </div>
      )}

      {/* Scrollable Content Area */}
      <div className="flex-1 overflow-y-auto overflow-x-hidden min-h-0">
        {/* Academic Management Section */}
        <div className="mb-4">
          <AcademicManagement />
        </div>

        {/* System Management Section Header */}
        <div className="mb-3">
          <div className="flex items-center gap-2 px-1">
            <Bot className="w-4 h-4 text-blue-400" />
            <h2 className="text-sm font-semibold text-white">Gestión del sistema</h2>
          </div>
        </div>

        {/* Main Content */}
        <div className="flex flex-col md:flex-row gap-4 min-h-0 md:min-h-[400px]">
        {/* Left: Agent List - scrollable only if needed */}
        <div className="w-full md:w-48 flex-shrink-0 space-y-1.5 overflow-y-auto overflow-x-hidden">
          {AGENT_PROFILES.map(agent => (
            <AgentCard
              key={agent.id}
              agent={agent}
              isSelected={selectedAgent.id === agent.id && !showAnalyticsPanel}
              onClick={() => {
                setSelectedAgent(agent);
                setShowAnalyticsPanel(false);
              }}
              ragCount={getRagCount(agent.id)}
            />
          ))}
          
          {/* Analytics Panel Entry */}
          <button
            onClick={() => setShowAnalyticsPanel(true)}
            className={`w-full flex items-center gap-2.5 px-3 py-2.5 rounded-xl transition-all duration-200 text-left ${
              showAnalyticsPanel
                ? 'bg-gradient-to-r from-blue-600/30 to-purple-600/30 border border-blue-500/50 shadow-lg shadow-blue-500/10'
                : 'bg-gray-800/40 border border-gray-700/50 hover:bg-gray-700/50 hover:border-gray-600/50'
            }`}
            data-testid="analytics-panel-btn"
          >
            <div className={`p-1.5 rounded-lg ${showAnalyticsPanel ? 'bg-blue-500/30' : 'bg-gray-700/50'}`}>
              <BarChart3 className={`w-4 h-4 ${showAnalyticsPanel ? 'text-blue-400' : 'text-gray-400'}`} />
            </div>
            <div className="flex-1 min-w-0">
              <p className={`text-xs font-medium truncate ${showAnalyticsPanel ? 'text-white' : 'text-gray-300'}`}>
                Monitoreo y Analítica
              </p>
              <p className="text-[10px] text-gray-500 truncate">Tráfico y estadísticas</p>
            </div>
          </button>
        </div>

        {/* Right: Agent Config OR Analytics Panel */}
        <div className="flex-1 flex flex-col gap-3 overflow-y-auto overflow-x-hidden min-h-0">
          {/* Show Analytics Panel */}
          {showAnalyticsPanel ? (
            <div className="space-y-4">
              {/* Analytics Header */}
              <div className="bg-gray-800/50 rounded-xl p-4 border border-gray-700/50">
                <div className="flex items-center gap-3 mb-2">
                  <div className="p-2 rounded-lg bg-gradient-to-br from-blue-500/20 to-purple-500/20">
                    <BarChart3 className="w-6 h-6 text-blue-400" />
                  </div>
                  <div>
                    <h2 className="text-lg font-semibold text-white">Monitoreo y Analítica de Tráfico</h2>
                    <p className="text-xs text-gray-400">Estadísticas de uso, sesiones y ubicación de usuarios</p>
                  </div>
                </div>
              </div>
              
              {/* PIN Protection for Analytics */}
              {!isAnalyticsUnlocked ? (
                <div className="bg-gray-800/50 rounded-xl p-6 border border-gray-700/50 text-center">
                  <Lock className="w-12 h-12 text-gray-500 mx-auto mb-4" />
                  <h3 className="text-white font-medium mb-2">Acceso Protegido</h3>
                  <p className="text-sm text-gray-400 mb-4">Ingresa el PIN para ver las estadísticas del sistema</p>
                  <button
                    onClick={() => setShowAnalyticsPinInput(true)}
                    className="px-4 py-2 bg-blue-600 hover:bg-blue-500 text-white rounded-lg transition-colors"
                  >
                    Desbloquear
                  </button>
                  
                  {showAnalyticsPinInput && (
                    <div className="mt-4">
                      <PinInput
                        onSubmit={handleAnalyticsPinSubmit}
                        error={analyticsPinError}
                        isLoading={false}
                        onCancel={() => setShowAnalyticsPinInput(false)}
                      />
                    </div>
                  )}
                </div>
              ) : (
                <AnalyticsPanel pin={analyticsPin} showMap={true} showConversations={true} />
              )}
            </div>
          ) : (
            <>
          {/* Agent Header - Editable for subject agents */}
          <EditableSubjectHeader
            subject={{
              id: selectedAgent.id,
              name: subjectData[getSubjectIdForRag(selectedAgent.id)]?.name || selectedAgent.name,
              description: subjectData[getSubjectIdForRag(selectedAgent.id)]?.description || selectedAgent.description,
              isDefault: selectedAgent.isDefault
            }}
            onUpdate={(updates) => handleUpdateSubject(getSubjectIdForRag(selectedAgent.id), updates)}
            isLoading={isLoading}
          />

          {/* PIN Input */}
          {showPinInput && (
            <PinInput
              onSubmit={handlePinSubmit}
              error={pinError}
              isLoading={false}
              onCancel={() => setShowPinInput(false)}
            />
          )}

          {/* Knowledge Section (above Instructions) */}
          {!showPinInput && (
            <KnowledgeSection
              docs={ragDocs}
              subjectId={getSubjectIdForRag(selectedAgent.id)}
              onUpload={handleUploadDoc}
              onDelete={handleDeleteDoc}
              isLoading={isLoading}
            />
          )}

          {/* Multimedia Section (between Knowledge and Instructions) */}
          {!showPinInput && (
            <MultimediaSection
              items={multimedia}
              subjectId={getSubjectIdForRag(selectedAgent.id)}
              onUpload={handleUploadMultimedia}
              onDelete={handleDeleteMultimedia}
              onUpdate={handleUpdateMultimedia}
              isLoading={isLoading}
              onShowAlert={showAlert}
            />
          )}

          {/* Learning Plan Editor - Only for subject agents, not default */}
          {!showPinInput && !selectedAgent.id.startsWith('default-') && (
            <LearningPlanEditor
              subjectId={getSubjectIdForRag(selectedAgent.id)}
              subjectName={selectedAgent.name}
            />
          )}

          {/* Instructions Section */}
          {!showPinInput && (
            <InstructionsSection
              prompt={getCurrentPrompt()}
              isUnlocked={isPromptUnlocked}
              onUnlockRequest={() => setShowPinInput(true)}
              onSave={handleSavePrompt}
              isSaving={isSaving}
            />
          )}

          {/* Advanced Configuration Section - Only visible when unlocked with PIN */}
          {!showPinInput && isPromptUnlocked && (
            <AdvancedConfigSection
              config={getCurrentAgentConfig()}
            />
          )}

          {/* Diagnostic Section - Only visible when unlocked with PIN */}
          {!showPinInput && isPromptUnlocked && (
            <DiagnosticSection
              subjectId={getSubjectIdForRag(selectedAgent.id)}
              subjectName={selectedAgent.name}
            />
          )}

          {/* Chunks Viewer Section - Only visible when unlocked with PIN */}
          {!showPinInput && isPromptUnlocked && (
            <ChunksViewerSection
              subjectId={getSubjectIdForRag(selectedAgent.id)}
              subjectName={selectedAgent.name}
            />
          )}

          {/* Analytics & Monitoring Section - Removed from here, now in separate panel */}
            </>
          )}
        </div>
        </div>
      </div>

      {/* Alert Modal */}
      <AlertModal
        isOpen={alertModal.isOpen}
        onClose={closeAlert}
        title={alertModal.title}
        message={alertModal.message}
        type={alertModal.type}
      />

      {/* Confirm Modal */}
      <ConfirmModal
        isOpen={confirmModal.isOpen}
        onClose={closeConfirm}
        onConfirm={confirmModal.onConfirm}
        title={confirmModal.title}
        message={confirmModal.message}
        type={confirmModal.type}
        confirmText="Eliminar"
        cancelText="Cancelar"
      />
    </div>
  );
};

export default MisClasesView;
